import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { GungNotificationService } from 'gung-common';
import { ConfigurationsService, GungConfiguration } from '../../../services/configurations.service';
import { GungSettingsBaseViewComponent } from '../../gung-settings-base-view/gung-settings-base-view.component';

@Component({
  selector: 'lib-gung-settings-zendr-sender-config',
  standalone: false,
  templateUrl: './gung-settings-zendr-sender-config.component.html',
  styleUrl: './gung-settings-zendr-sender-config.component.scss'
})
export class GungSettingsZendrSenderConfigComponent extends GungSettingsBaseViewComponent implements OnInit {
  protected formBuilder = inject(FormBuilder);
  protected configurationsService = inject(ConfigurationsService);
  protected gungNotificationService = inject(GungNotificationService);
  protected translateService = inject(TranslateService);

  public form: FormGroup;
  protected configuration: GungConfiguration;
  public loaded = false;

  ngOnInit(): void {
    this.configurationsService.getConfigurationsByIds(['ZendrSenderConfig'], true).subscribe(configs => {
      if (!configs || configs.length === 0) {
        return;
      }

      this.configuration = configs[0];
      this.initForm();
      this.loaded = true;
    });
  }

  initForm() {
    this.form = this.formBuilder.group({
      contactName: this.formBuilder.control(this.configuration.contactName),
      contactCompany: this.formBuilder.control(this.configuration.contactCompany),
      contactExternalCustomerId: this.formBuilder.control(this.configuration.contactExternalCustomerId),
      contactEmail: this.formBuilder.control(this.configuration.contactEmail),
      contactPhoneNumber: this.formBuilder.control(this.configuration.contactPhoneNumber),
      contactVatNumber: this.formBuilder.control(this.configuration.contactVatNumber),
      addressPostalCode: this.formBuilder.control(this.configuration.addressPostalCode),
      addressPostalTown: this.formBuilder.control(this.configuration.addressPostalTown),
      addressCountryCode: this.formBuilder.control(this.configuration.addressCountryCode),
      addressState: this.formBuilder.control(this.configuration.addressState),
      addressLine1: this.formBuilder.control(this.configuration.addressLine1),
      addressLine2: this.formBuilder.control(this.configuration.addressLine2),
      addressLine3: this.formBuilder.control(this.configuration.addressLine3)
    });
  }

  save() {
    Object.assign(this.configuration, this.form.value);
    this.configurationsService.updateConfiguration(this.configuration).subscribe(() => {
      this.gungNotificationService.notify(
        this.translateService.instant('ZENDR_SENDER_CONFIG_SAVED'),
        null,
        'success'
      );
    });
  }
}
